module.exports = __webpack_public_path__ + "img/ddhq_logo_stacked.80f51def.png";